import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import { ONTOLOGY_WORKBENCH_STEPS } from "../../data/create-ontology-questions.data";
import "./CreateOntologyCqReview.scss";

// Step 3 (CQ Review) — placeholder scaffold; full design pending Figma handoff.
const CreateOntologyCqReview: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initiativeId = (location.state as { initiativeId?: string } | null)
    ?.initiativeId;

  return (
    <div className="cq-review-container">
      <nav className="cq-review-breadcrumb">
        <Link to="/home" className="breadcrumb-link">
          Engineering Information Management
        </Link>
        <span className="breadcrumb-separator">&gt;</span>
        <Link to="/create-ontology" className="breadcrumb-link">
          Ontology Studio
        </Link>
        <span className="breadcrumb-separator">&gt;</span>
        <span className="breadcrumb-current">CQ Review</span>
      </nav>

      <div className="cq-review-header">
        <h1 className="cq-review-title">CQ Review</h1>
        <p className="cq-review-description">
          {initiativeId
            ? `Initiative ${initiativeId} — this step's design is coming soon.`
            : "This step's design is coming soon."}
        </p>
      </div>

      <div className="cq-review-workflow">
        {ONTOLOGY_WORKBENCH_STEPS.map((step) => (
          <div
            key={step.id}
            className={`cq-review-workflow__step${
              step.id === 2 ? " cq-review-workflow__step--active" : ""
            }${step.id < 2 ? " cq-review-workflow__step--done" : ""}`}
          >
            <span className="cq-review-workflow__indicator">
              {step.id < 2 ? (
                <CheckCircleOutlined fontSize="inherit" />
              ) : step.id === 2 ? (
                "•"
              ) : (
                ""
              )}
            </span>
            <span className="cq-review-workflow__label">{step.label}</span>
          </div>
        ))}
      </div>

      <div className="cq-review-footer">
        <button
          type="button"
          className="cq-review-btn cq-review-btn--secondary"
          onClick={() => navigate("/ontology-studio/create/questions")}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default CreateOntologyCqReview;
